import { ModuleTypes } from '$const';
import getStore from '$store';
import { selectEntitiesState } from '~store/selectors/entities';
import { selectMenuElementById } from '~store/selectors/menu';
import { getFieldValue, makeSlugForAnchorEntity } from './entity-helpers';
import { getModuleUrlIdFromData } from './location-helpers';

export interface ITargetModuleData {
  // the module identifier
  id?: string;
  type?: string;
}

export interface ITextLinkData extends ITargetModuleData {
  // either a url to an external site
  url?: string;
  useExternal?: boolean;
}

export function getUrlFromTextLink({ url, id, type, useExternal }: ITextLinkData): string {
  if (!id || !type || useExternal) {
    return url;
  }

  if (type === ModuleTypes.internalLink) {
    const element = selectMenuElementById(getStore().getState(), id);
    return `${element ? element.alias : ''}`;
  }
}

export function getUrlFromTextLinkData({ url, id, type, useExternal }: ITextLinkData): string {
  if (!id || !type || useExternal) {
    return url;
  }

  const moduleId = getModuleUrlIdFromData(id, type);

  if (type === ModuleTypes.internalLink) {
    const element = selectMenuElementById(getStore().getState(), id);
    return `${element ? element.alias : ''}#${moduleId}`;
  } else if (type === ModuleTypes.anchorLink) {
    const entities = selectEntitiesState(getStore().getState());
    const entity = entities[id];
    if (!entity) {
      throw new Error(`Entity with id ${id} not found!`);
    }
    const entityData = entity.data;

    return `${getFieldValue<string>(entityData, 'attributes.field_path')}/${makeSlugForAnchorEntity(
      entityData,
    )}#${moduleId}`;
  }
}
